import gql from "graphql-tag";

const UPDATE_USER = gql`
  mutation updateUser($userId: ID!, $userData: UpdateUserInput!) {
    updateUser(userId: $userId, userData: $userData)
  }
`;

export default UPDATE_USER;
